import {ApiService} from './api.service';
import {Injectable} from '@angular/core';
import {map} from 'rxjs/operators';
import {TemplateFieldConfig} from 'src/app/shared/models/template-field-config.model';

const API_GET_ALL_TEMPLATE_FIELD_CONFIG = '/dc/template-field-configs/get-all';
const API_SAVE_ALL_TEMPLATE_FIELD_CONFIG = '/dc/template-field-configs/save-all';
const API_DELETE_TEMPLATE_FIELD_CONFIG = '/dc/template-field-configs/delete-all';

@Injectable({
    providedIn: 'root'
})
export class TemplateFieldConfigService {

    constructor(private apiService: ApiService) { }

    getTemplateFieldConfig(templateId: number) {
        return this.apiService.get(`${API_GET_ALL_TEMPLATE_FIELD_CONFIG}?templateId=${templateId}`)
            .pipe(map(res => {
                return res;
            }));
    }

    saveAllTemplateFieldConfig(body: Array<TemplateFieldConfig>, templateId: number) {
        return this.apiService.post(API_SAVE_ALL_TEMPLATE_FIELD_CONFIG + '?templateId=' + templateId, body)
            .pipe(map(res => {
                return res;
            }));
    }

    deleteTemplateFieldConfig(ids: Array<number>) {
        return this.apiService.post(API_DELETE_TEMPLATE_FIELD_CONFIG, ids)
            .pipe(map(res => {
                return res;
            }));
    }


}
